export default __webpack_public_path__ + "static/media/MobileAppImage.e47b66b7.png";